import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import Home from "./componentsBlock/Home";
import Campaigns from "./componentsBlock/Campaigns";
import Payments from "./componentsBlock/Payments";
import Templates from "./componentsBlock/Templates";
import Settings from "./componentsBlock/Settings";
import NewCampaign from "./componentsBlock/NewCampaign";

const navItems = [
  { to: "/dashboard", label: "Home", icon: "🏠" },
  { to: "/campaigns", label: "Campaigns", icon: "📣" },
  { to: "/payments", label: "Payments", icon: "💲" },
  { to: "/templates", label: "Templates", icon: "📄" },
  { to: "/settings", label: "Settings", icon: "⚙️" },
  { to: "/new-campaign", label: "New Campaign", icon: "➕" },
];

function DashboardNav({creatorData}) {
 // console.log("Creator Data:", creatorData);
    const [activePanel, setActivePanel] = useState("Home");
  const navigate = useNavigate();
  const location = useLocation();
  const handlePanelClick = (panel) => {
    setActivePanel(panel);
  };



  return (
    <div className="flex min-h-screen bg-gray-50" style={{ overflow: "hidden",fontFamily:"Gilroy-Medium" }}>
      <aside className="w-64 bg-white shadow-md p-4">
        <div className="text-xl font-bold mb-6">CreatorPay</div>
        <nav className="space-y-3">
          {navItems.map((item) => (
            <NavItem
              key={item.to}
              to={item.to}
              label={item.label}
              icon={item.icon}
              active={location.pathname === item.to}
              setActivePanel={setActivePanel}
            />
          ))}
        </nav>
        <div className="mt-10">
          <button
            className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={() => handlePanelClick(navItems.label)}
          >
            New Campaign
          </button>
          <div className="mt-4 text-sm text-gray-500 text-center">
            Help and docs
          </div>
        </div>
      </aside>

      <div className="flex-1 overflow-scroll bg-white p-2">
        {activePanel === "Home" && <Home />}

        {activePanel === "Campaigns" && <Campaigns creatorData={creatorData} />}
        {activePanel === "Payments" && <Payments />}
        {activePanel === "Templates" && <Templates />}
        {activePanel === "Settings" && <Settings />}
        {activePanel === "New Campaign" && <NewCampaign  creatorData={creatorData}/>}
      </div>
    </div>
  );
}

function NavItem({ to, label, icon, active, setActivePanel }) {
  const handlePanelClick = (panel) => {
    setActivePanel(panel);
  };
  return (
    <button
      type="button"
      onClick={() => handlePanelClick(label)}
      className={`flex items-center gap-2 px-3 py-2 rounded w-full text-left ${
        active
          ? "bg-blue-100 text-blue-700 font-semibold"
          : "hover:bg-blue-100 text-gray-700"
      }`}
    >
      <span>{icon}</span>
      <span>{label}</span>
    </button>
  );
}

export default DashboardNav;
